// FRC-1035: which public view a campaign's discovery card opens. Resolved by the backend from the
// Admin's per-campaign setting and the Campaign Summary's state; never derived on the frontend.
export enum CampaignDefaultView {
  CampaignPage = 0,
  CampaignSummary = 1,
}
